import { Link } from "react-router-dom";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { Seo, breadcrumbJsonLd } from "../components/Seo";
import { Testimonials } from "../components/Testimonials";
import { BUSINESS, CITIES } from "../data/site";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <Seo
        title="Contact 1st Nations Security | 24/7 Manitoba Security"
        description="Contact 1st Nations Security for security guard services anywhere in Manitoba. Call +1 807-770-0243 or email admin@1stnation-security.com — 24/7."
        path="/contact/"
        jsonLd={[breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Contact", path: "/contact" }])]}
      />
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="text-sm text-gray-500 mb-6" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#FF9100]" data-testid="breadcrumb-home">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-300">Contact</span>
          </nav>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white mb-6">
            Contact <span className="text-[#FF9100]">1st Nations Security</span>
          </h1>
          <p className="text-lg text-gray-400 leading-relaxed max-w-3xl mb-12">
            No forms, no waiting on callbacks. Reach our dispatch team directly by phone or email — we answer 24 hours a day, 7 days a week, and can arrange security guard services anywhere in Manitoba.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl">
            <a
              href={BUSINESS.phoneHref}
              data-testid="contact-phone-card"
              className="group bg-[#14161C] hover:bg-[#1C1F28] border border-[#FF9100]/30 hover:border-[#FF9100] rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 rounded-xl bg-[#FF9100]/10 border border-[#FF9100]/25 flex items-center justify-center text-[#FF9100] mb-4 group-hover:scale-110 transition-transform">
                <Phone className="w-6 h-6" />
              </div>
              <h2 className="font-heading text-xl font-semibold text-white mb-2">Call Us — 24/7 Dispatch</h2>
              <p className="font-heading text-2xl font-bold text-[#FF9100] mb-2">{BUSINESS.phone}</p>
              <p className="text-sm text-gray-400">Fastest response for urgent security needs, fire watch dispatch, and alarm response.</p>
            </a>

            <a
              href={BUSINESS.emailHref}
              data-testid="contact-email-card"
              className="group bg-[#14161C] hover:bg-[#1C1F28] border border-[#FF9100]/30 hover:border-[#FF9100] rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 rounded-xl bg-[#FF9100]/10 border border-[#FF9100]/25 flex items-center justify-center text-[#FF9100] mb-4 group-hover:scale-110 transition-transform">
                <Mail className="w-6 h-6" />
              </div>
              <h2 className="font-heading text-xl font-semibold text-white mb-2">Email Our Team</h2>
              <p className="text-lg font-semibold text-[#FF9100] mb-2 break-all">{BUSINESS.email}</p>
              <p className="text-sm text-gray-400">Best for quotes, contracts, and detailed site requirements — include your location and coverage needs.</p>
            </a>

            <div className="bg-[#14161C] border border-white/8 rounded-2xl p-8" data-testid="contact-hours-card">
              <div className="w-12 h-12 rounded-xl bg-[#FF9100]/10 border border-[#FF9100]/25 flex items-center justify-center text-[#FF9100] mb-4">
                <Clock className="w-6 h-6" />
              </div>
              <h2 className="font-heading text-xl font-semibold text-white mb-2">Hours of Operation</h2>
              <p className="text-gray-300 mb-1">24 hours a day, 7 days a week</p>
              <p className="text-sm text-gray-400">Including weekends and holidays — security never sleeps, and neither do we.</p>
            </div>

            <div className="bg-[#14161C] border border-white/8 rounded-2xl p-8" data-testid="contact-area-card">
              <div className="w-12 h-12 rounded-xl bg-[#FF9100]/10 border border-[#FF9100]/25 flex items-center justify-center text-[#FF9100] mb-4">
                <MapPin className="w-6 h-6" />
              </div>
              <h2 className="font-heading text-xl font-semibold text-white mb-2">Service Area</h2>
              <p className="text-gray-300 mb-1">All of Manitoba, Canada</p>
              <p className="text-sm text-gray-400">Winnipeg, Brandon, Steinbach, Thompson, and communities province-wide.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-[#0A0B0E]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-white mb-6">We Serve Your Community</h2>
          <div className="flex flex-wrap gap-2">
            {CITIES.map((c) => (
              <Link
                key={c.slug}
                to={`/security-guards/${c.slug}`}
                data-testid={`contact-city-${c.slug}`}
                className="text-xs text-gray-400 hover:text-[#FF9100] border border-white/10 hover:border-[#FF9100]/40 rounded-full px-3 py-1.5 transition-colors"
              >
                {c.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Testimonials />
    </div>
  );
}
